import { Editor, Path, Transforms, Range } from 'slate';

import emptyNode from '@ui/MarkdownEditor/emptyNode';
import type { OnKeyDown } from '@ui/MarkdownEditor/types';

import { Figcaption, Figure } from '../blocks';

const addParagraphAfterVoid: OnKeyDown = (event, editor) => {
  if (event.key !== 'Enter' || event.shiftKey || !editor.selection) return;

  const voidBlockEntry = Editor.above(editor, { match: n => Editor.isVoid(editor, n) && Editor.isBlock(editor, n) });
  if (!voidBlockEntry) return;

  event.preventDefault();
  event.stopPropagation();

  const at = Path.next(voidBlockEntry[1]);
  Transforms.insertNodes(editor, emptyNode(), { at, select: true });
};

const figcaptionEnter: OnKeyDown = (event, editor) => {
  if (!(event.key === 'Enter' && !event.shiftKey && editor.selection)) return;

  const captionEntry = Editor.above(editor, { match: Figcaption.is });
  if (!captionEntry) return;

  const [, captionPath] = captionEntry;

  event.preventDefault();
  event.stopPropagation();

  Editor.withoutNormalizing(editor, () => {
    if (!editor.selection) return;

    if (!Range.isCollapsed(editor.selection)) {
      Transforms.delete(editor, { at: editor.selection });
    }

    Transforms.splitNodes(editor, { always: true, match: n => Figure.is(n) });
    Transforms.unwrapNodes(editor, { mode: 'all', match: n => Figure.is(n) || Figcaption.is(n) });
    Transforms.select(editor, Editor.after(editor, captionPath)!);
  });
};

const shiftEnter: OnKeyDown = (event, editor) => {
  if (event.key === 'Enter' && event.shiftKey) {
    event.preventDefault();
    event.stopPropagation();

    editor.insertText(editor.props.useMDX ? '  \n' : '\n');
  }
};

export default [addParagraphAfterVoid, figcaptionEnter, shiftEnter];
